import React from "react"
import types from "prop-types"

const EditSubmissionOptionCard = ({ description, onClick, title }) => (
  <button
    className="w-full sm:w-60 min-h-[200px] p-4 flex flex-col items-center text-center bg-white
               border border-lightgray-3 rounded-lg input-focus-ring"
    onClick={onClick}
    type="button"
  >
    <span className="mb-4 font-medium text-lg">{title}</span>
    <span className="w-full text-left text-sm text-gray leading-6">{description}</span>
  </button>
)

EditSubmissionOptionCard.propTypes = {
  description: types.string.isRequired,
  onClick: types.func.isRequired,
  title: types.string.isRequired,
}

export default EditSubmissionOptionCard
